/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Loader from '../../Components/Utility/Loader/Loader';
import './SupplierSuggestion.css';
import { getSuggestionDetail, getBomComponentProductRef, getHideShowGrading } from './store/SupplierSuggestion.action';
import { shortenStringWithTooltip } from '../../Components/helper';

import TestingSuggestionCard from './Module/Testing/TestingSuggestionCard';
import BomSuggestionCard from './Module/Bom/BomSuggestionCard';
import MeasurementCard from './Module/Measurement/MeasurementCard';
import CareLabelCard from './Module/CareLabels/CareLabelCard';
import * as bomAction from '../DevlopmentOrder/Bom/store/BOMConfig.action';
import { useComponent } from '../UserSetting/UsersLibrary/UserRights';
import CustomTooltip from '../../Components/Tooltip/CustomTooltip';
import ProductSuggestion from './Module/ProductInformation/ProductSuggestionCard';
import * as devOrderAction from '../DevlopmentOrder/store/DevelopmentOrder.action';

function SuggestionDetail({ match }) {
  const history = useHistory();
  const [loader, setLoader] = useState(false);
  const [suggestionData, setSuggestionData] = useState(null);
  const [showGrading, setShowGrading] = useState(false);
  const [disableApproveReject, setDisableApproveReject] = useState(true);
  const [conversationData, setConversationData] = useState({
    conversionType: '',
  });
  const [approveReject, setApproveReject] = useState(false);
  const [showApproveReject, setShowApproveReject] = useState(false);
  const [detailType, setDetailType] = useState(null);
  const dispatch = useDispatch();
  const { t } = useTranslation('common');
  const CareLabel = 'care-label';
  const {
    SupplierSuggestion: { MeasurementSuggestion },
    Users: { logInRights },
    UserDetails: { userInfo },
  } = useSelector((state) => state);

  const { CheckActionPermission } = useComponent();
  const unMountStates = () => {
    dispatch(bomAction.unMount());
    setLoader(false);
    setSuggestionData(null);
    setShowGrading(false);
    setDisableApproveReject(true);
    setConversationData({ conversionType: '' });
    setApproveReject(false);
    setShowApproveReject(false);
    setDetailType();
  };
  useEffect(() => {
    return () => {
      unMountStates();
    };
  }, []);

  const secondSuggestionCondition = () => {
    return suggestionData?.section === CareLabel ? 'Care Label' : <span className="text-capitalize">{suggestionData?.section}</span>;
  };

  const toCheckAddEditPermission = (name) => {
    return CheckActionPermission(logInRights, 'products', name, 'addEdit');
  };

  const switchToAccessModal = (name) => {
    switch (name) {
      case 'bom':
        return toCheckAddEditPermission('bom');
      case 'measurement':
        return toCheckAddEditPermission('measurement');
      case 'testing':
        return toCheckAddEditPermission('testing');
      case 'product-information':
        return toCheckAddEditPermission('addProduct');
      default:
        return toCheckAddEditPermission('care');
    }
  };

  const sugestionObj = {
    suggestionId: match?.params?.id,
    section: match?.params?.section,
  };

  const getDetail = async () => {
    setLoader(true);
    const data = await dispatch(getSuggestionDetail(sugestionObj, t));
    if (data) {
      const deepClone = JSON.parse(JSON.stringify(data));
      const bomTypeId = data?.bomType?._id;
      const bomComponent = data?.bomComponents;

      /* GET BOM TYPE FROM PRODUCT REF */
      if (bomTypeId !== null && data?.type !== 'new' && data?.section === 'bom') {
        const devIds = bomComponent?.map((item) => item?.devOrderId?._id) || [];

        const document = {
          bomType: bomTypeId,
          devIds,
        };
        await dispatch(getBomComponentProductRef(document));
      }
      const devorderId = deepClone.devOrderIds[0]._id;
      if (data?.productInformationLibraries) {
        await dispatch(devOrderAction.getSuggestionProductDetail(devorderId));
      } else if (devorderId) await dispatch(bomAction.fetchProductDetails(devorderId));

      /* GET BOM TYPE FROM PRODUCT REF END */
      setSuggestionData(deepClone);
      setDetailType(data?.section);
    }
    setLoader(false);
  };

  const checkMeasurementApproveRejectButton = async (checkData) => {
    const measurementPom = checkData?.pom;
    const measurementOther = checkData?.other;

    const pendingActionPom =
      measurementPom && measurementPom?.length > 0 && measurementPom?.filter((item) => !['Approved', 'Deleted'].includes(item?.status))?.length;
    const pendingActionOther =
      measurementOther && measurementOther?.length > 0 && measurementOther?.filter((item) => !['Approved', 'Deleted'].includes(item?.status))?.length;

    let total = 0;
    if (pendingActionPom) {
      total += pendingActionPom;
    }
    if (pendingActionOther) {
      total += pendingActionOther;
    }
    if (total > 0) {
      setShowApproveReject(true);
    } else {
      setShowApproveReject(false);
    }
  };
  const checkCareLabelApproveRejectButton = async (checkData) => {
    // Initialize results
    const hasPendingOrRejected = [];
    const hasApprovedOrDeleted = [];

    // Iterate over each tab
    checkData.forEach((tab) => {
      // Check if any tabDetail contains "Pending" or "Rejected"
      const pendingOrRejected = tab.tabDetails.some((detail) => ['Pending', 'Rejected'].includes(detail.status));

      // Check if any tabDetail contains "Approved" or "Deleted"
      const approvedOrDeleted = tab.tabDetails.every((detail) => ['Approved', 'Deleted'].includes(detail.status));

      // Update results if found
      hasPendingOrRejected.push(pendingOrRejected);

      hasApprovedOrDeleted.push(approvedOrDeleted);
    });
    if (!hasApprovedOrDeleted.includes(false)) {
      setShowApproveReject(false);
    }
    if (hasPendingOrRejected.includes(true)) {
      setShowApproveReject(true);
    }
  };
  const checkTestingApproveRejectButton = async (checkData) => {
    const testingLibraries = checkData;
    const pendingActionTesting =
      testingLibraries && testingLibraries.length > 0 && testingLibraries?.filter((item) => !['Approved', 'Deleted'].includes(item.status))?.length;

    let total = 0;
    if (pendingActionTesting) {
      total += pendingActionTesting;
    }
    if (total > 0) {
      setShowApproveReject(true);
    } else {
      setShowApproveReject(false);
    }
  };

  const checkBomApproveRejectButton = async (checkData) => {
    const bomComponents = checkData;

    const pendingActionBom =
      bomComponents && bomComponents?.length > 0 && bomComponents?.filter((item) => !['Approved', 'Deleted'].includes(item?.status))?.length;

    let total = 0;
    if (pendingActionBom) {
      total += pendingActionBom;
    }
    if (total > 0) {
      setShowApproveReject(true);
    } else {
      setShowApproveReject(false);
    }
  };

  const checkProductApproveRejectButton = async (checkData) => {
    const productData = checkData;
    const pendingActionTesting = productData && productData.length > 0 && productData?.filter((item) => !['Approved', 'Deleted'].includes(item.status))?.length;

    let total = 0;
    if (pendingActionTesting) {
      total += pendingActionTesting;
    }
    if (total > 0) {
      setShowApproveReject(true);
    } else {
      setShowApproveReject(false);
    }
  };

  const updateData = async () => {
    setApproveReject();
    getDetail();
  };

  const getGradingData = async () => {
    const [{ _id }] = suggestionData.devOrderIds;
    const obj = {
      gradings: !showGrading,
      loggedInUserId: userInfo.userId,
      gradingGroupId: suggestionData?.gradingGroupId,
    };

    const response = await dispatch(getHideShowGrading(_id, obj));
    if (response) {
      setShowGrading(!showGrading);
    }
  };

  useEffect(() => {
    if (MeasurementSuggestion.length > 0) {
      setConversationData({
        conversionType: suggestionData?.gradingGroup?.conversationType,
      });
    }
  }, [MeasurementSuggestion]);
  const approveRejectDisable = async (enable) => {
    setDisableApproveReject(enable);
  };
  const updatedSuggestionLibrary = async (data) => {
    if (data && data.length === 1 && detailType !== CareLabel) {
      approveRejectDisable(false);
    }
    if (detailType === 'measurement') {
      checkMeasurementApproveRejectButton(data);
    } else if (detailType === CareLabel) {
      checkCareLabelApproveRejectButton(data);
    } else if (detailType === 'testing') {
      checkTestingApproveRejectButton(data);
    } else if (detailType === 'bom') {
      checkBomApproveRejectButton(data);
    } else if (detailType === 'product-information') {
      checkProductApproveRejectButton(data);
    }
  };

  useEffect(() => {
    getDetail();
  }, []);
  return (
    <>
      <div className="page-title-filter sticky">
        <div className="title-container">
          <h4 className="title">{t('SUGGESTION_DETAILS.TITLE')}</h4>
        </div>
        <div className="search-filter">
          {(userInfo.role === 'Admin' || userInfo.role === 'User') && showApproveReject && switchToAccessModal(suggestionData?.section) && (
            <div className="floting-actions">
              <CustomTooltip placement="top" tooltipText={t('SUGGESTION_DETAILS.APPROVE')}>
                <button
                  type="button"
                  aria-label="approve"
                  onClick={() =>
                    setApproveReject({
                      status: true,
                      action: 'Approved',
                    })
                  }
                  className="btn "
                  disabled={disableApproveReject}
                >
                  <i className="icon-Yes" />
                </button>
              </CustomTooltip>
              <CustomTooltip placement="top" tooltipText={t('SUGGESTION_DETAILS.REJECT')}>
                <button
                  type="button"
                  onClick={() =>
                    setApproveReject({
                      status: true,
                      action: 'Rejected',
                    })
                  }
                  aria-label="reject"
                  className="btn  "
                  disabled={disableApproveReject}
                >
                  <i className="icon-No-Variant" />
                </button>
              </CustomTooltip>
            </div>
          )}
          <div className="break" />
          {suggestionData?.measurementLibaries && suggestionData?.measurementLibaries?.length > 0 && (
            <button className="btn btn-white btn-back-lib my-1 mr-16 my-md-0" type="button" onClick={() => getGradingData()}>
              {showGrading ? t('SUGGESTION_DETAILS.HIDE_GRADING') : t('SUGGESTION_DETAILS.SHOW_GRADING')} {t('SUGGESTION_DETAILS.GRADING')}
            </button>
          )}
          <button
            type="button"
            onClick={() => {
              history.goBack();
            }}
            aria-label="close"
            className="btn p-0"
          >
            <i className="icon-close f-20" />
          </button>
        </div>
      </div>
      <div className="container-fluid suggestion-detail-container">
        {loader ? (
          <Loader />
        ) : (
          <div className="suggestion-detail">
            <div className="d-flex flex-wrap flex-md-nowrap align-items-center mb-3">
              <div className="table-responsive">
                <table className="table common-custom-table mb-0">
                  <thead>
                    <tr>
                      {(suggestionData?.type === 'new' || suggestionData?.section !== 'bom') && <th>{t('SUGGESTION_DETAILS.PRODUCT_REFS')}</th>}
                      <th>{t('SUGGESTION_DETAILS.SECTION')}</th>
                      {suggestionData && suggestionData.section === 'measurement' && <th>{t('SUGGESTION_DETAILS.GRADING_GROUP')}</th>}
                      {suggestionData && suggestionData.section === 'bom' && <th>{t('SUGGESTION_DETAILS.BOM_TYPE')}</th>}
                      <th>{t('SUGGESTION_DETAILS.ACTION_TYPE')}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      {(suggestionData?.type === 'new' || suggestionData?.section !== 'bom') && (
                        <td>{suggestionData?.devOrderIds.map((devOrderId) => `${devOrderId.number}`).join(', ')}</td>
                      )}
                      <td>
                        <span className="text-capitalize">
                          {suggestionData?.section === 'bom' ? t('SUGGESTION_DETAILS.BILL_OF_MATERIALS') : secondSuggestionCondition()}
                        </span>
                      </td>
                      {suggestionData && suggestionData.section === 'measurement' && (
                        <td>
                          <span className="text-capitalize">{suggestionData?.gradingGroup?.name}</span>
                        </td>
                      )}
                      {suggestionData && suggestionData.section === 'bom' && (
                        <td>
                          <span className="text-capitalize">{suggestionData?.bomType?.name}</span>
                        </td>
                      )}
                      <td>
                        <span className="text-capitalize">{suggestionData?.type}</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              {suggestionData && suggestionData.section === 'measurement' && conversationData?.conversionType !== '' && (
                <div className="detail-unit-section">
                  <p className="mb-2">
                    {t('SUGGESTION_DETAILS.MEASUREMENT_UNIT')} {conversationData?.conversionType}
                  </p>
                </div>
              )}
            </div>
            <div>
              <p className="f-16 font-heavy">
                {t('SUGGESTION_DETAILS.COMMENT')}:&nbsp;
                {suggestionData?.comment ? <>{shortenStringWithTooltip(suggestionData?.comment, 200)}</> : <span>-</span>}
              </p>
            </div>
            {suggestionData && suggestionData?.productInformationLibraries?.length > 0 && (
              <ProductSuggestion
                suggestionData={suggestionData}
                suggestionType={suggestionData?.type}
                updateData={updateData}
                approveReject={approveReject}
                updatedSuggestionLibrary={updatedSuggestionLibrary}
                match={match}
              />
            )}

            {suggestionData && suggestionData.bomComponents.length > 0 && (
              <BomSuggestionCard
                suggestionData={suggestionData}
                updateData={updateData}
                approveReject={approveReject}
                suggestionType={suggestionData?.type}
                updatedSuggestionLibrary={updatedSuggestionLibrary}
                approveRejectDisable={approveRejectDisable}
                match={match}
                autoApproved={suggestionData?.autoApproval}
              />
            )}

            {suggestionData?.testLibraries && suggestionData?.testLibraries?.length > 0 && (
              <TestingSuggestionCard
                devOrderId={suggestionData.devOrderIds}
                bomTypeId={suggestionData.bomTypeId}
                userRole={userInfo.role}
                mainType={suggestionData?.type}
                testLibraries={suggestionData.testLibraries}
                updateData={updateData}
                comment={suggestionData?.comment}
                approveReject={approveReject}
                suggestionType={suggestionData?.type}
                sugestionObj={sugestionObj}
                updatedSuggestionLibrary={updatedSuggestionLibrary}
                approveRejectDisable={approveRejectDisable}
                autoApproved={suggestionData?.autoApproval}
              />
            )}
            {suggestionData && suggestionData?.measurementLibaries?.length > 0 && (
              <MeasurementCard
                suggestionData={suggestionData}
                measurementLibaries={suggestionData.measurementLibaries[0]}
                devOrderId={suggestionData.devOrderIds}
                suggestionType={suggestionData?.type}
                showGrading={showGrading}
                // setDetailUnit={setDetailUnit}
                approveReject={approveReject}
                sugestionObj={sugestionObj}
                updateData={updateData}
                conversationData={conversationData}
                updatedSuggestionLibrary={updatedSuggestionLibrary}
                approveRejectDisable={approveRejectDisable}
                autoApproved={suggestionData?.autoApproval}
              />
            )}

            {suggestionData && suggestionData?.careLableLibaries?.length > 0 && (
              <CareLabelCard
                careLibaries={suggestionData.careLableLibaries[0]}
                devOrderId={suggestionData.devOrderIds}
                suggestionType={suggestionData?.type}
                approveReject={approveReject}
                sugestionObj={sugestionObj}
                updateData={updateData}
                updatedSuggestionLibrary={updatedSuggestionLibrary}
                approveRejectDisable={approveRejectDisable}
                autoApproved={suggestionData?.autoApproval}
              />
            )}
          </div>
        )}
      </div>
    </>
  );
}

export default SuggestionDetail;
